import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const selectLocationsSlice = createSelector(
  (state: RootState) => state.locations,
  (state) => state,
);

/** Локация, открытая в карточке. Перечень читается через RTK Query. */
export const selectCurrentLocation = createSelector([selectLocationsSlice], (state) => state.currentLocation);

export const selectProcess = createSelector([selectLocationsSlice], (state) => ({
  isProcessing: state.isProcessing,
  isProcessed: state.isProcessed,
  name: state.processName,
}));

export const selectIsProcessing = createSelector([selectProcess], (state) => ({
  isProcessing: state.isProcessing,
  isProcessed: state.isProcessed,
}));
